import noAuthApiClient from 'hub-http/clients/noAuthApiClient';
import enviro from 'enviro';
import { getUtk } from 'usage-tracker-core/common/defaultTrackers';
export function fetchPublicVisitorContext() {
  const utk = getUtk();
  return noAuthApiClient.get(`https://t.hs-growth-metrics${enviro.isProd() ? '' : 'qa'}.com/reporting/v1/context/utk`, {
    query: {
      utk
    }
  });
}